import React, { useContext, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
/* --------------------------------------------- */
import { routeMap } from '../../route'
/* --------------------------------------------- */
import utils from '../../utils/utils'
/* --------------------------------------------- */
import { GlobalContext } from '../../context/global.context'
/* --------------------------------------------- */
import CloseIcon from '.././icons/CloseIcon'
import Spinner from '.././Spinner'
import PlayButton from '../PlayButton'
import {
  DetailsPagePopupHeader, BodyTextSecondary, DetailsPagePopupHeaderPrimary, MetaBodyTextSecondary,
  MetaBodyTextTertiary, DetailsPageBadges, DescriptionText
} from './style'
import { DetailsPopup } from '../DetailsSection/style'
/* --------------------------------------------- */
// MediaDetailsPopUp component used to display media details popup.
const MediaDetailsPopUp = ({ isShow, closeBtnHandle, railItemDetails, title, type, shouldShowPlay }) => {
  const { metaTheme } = useSelector(store => store.themeConfigReducers)
  const { appMessages } = useSelector(store => store.appConfigReducers)
  /* --------------------------------------------- */
  const {  dispatch: globalDispatch } = useContext(GlobalContext)
  /* --------------------------------------------- */
  const history = useHistory()
  const detailsPopupRef = useRef(null)

  /**
   * When: On watch now button click.
   * It: Opens player.
   */
  const showPlayer = () => {
    const state = {
      "details": {
        "url": "https://link.theplatform.com/s/tzTJhC/media/ad_yEfI0NVSl",
        "title": `${(railItemDetails && railItemDetails.episodeTitle && railItemDetails.episodeTitle) || 'Relativity'}`,
        "subTitle": null,
        "details": [
          {
            "key": "date"
          },
          {
            "key": "association"
          },
          {
            "key": "countries",
            "label": "Country",
            "value": null
          },
          {
            "key": "availableTill",
            "label": "Available For",
            "value": null
          },
          {
            "key": "genre",
            "label": "Genre",
            "value": [
              {
                "title": "History"
              },
              {
                "title": "Documentary"
              }
            ]
          },
          {
            "key": "cast",
            "label": "Cast",
            "value": null
          },
          {
            "key": "director",
            "label": "Director",
            "value": null
          }
        ],
        "description": "Example content containing multi-language captions and audio.",
        "timeLeft": 0,
        "mediaId": "277046310581",
        "seriesId": "",
        "seasonId": null,
        "trailers": [],
        "movieSeriesId": "277046310581",
        "castConfigPlaybackFormat": "MPEG-DASH+widevine",
        "isLivePlayer": false,
        "isShowFavourites": false,
        "isSportingEvent": false,
        "seasonData": null,
        "curentSeason": null,
        "type": "movie",
        "appMessages": {
          "error_ext": "Exit",
          "error_media_access_fail": "Failed to access media.\n",
          "error_no_content": "No matching items found",
          "error_no_internet": "Unable to stream. Please check your internet connection.",
          "error_no_network_desc": "Unable to connect to the server. Please check your network",
          "error_retry": "Retry",
          "error_something_wrong": "Something went wrong.\n",
          "error_stream_fetch": "There was an error fetching the stream information.",
          "error_video_unsupported": "Video format unsupported",
          "app_popup_stream_not_found": "The requested stream is not found",
          "error_media_content_unavailable_in_your_country": "This content is not available in your country",
          "error_media_access_denied": "You don't have access to play this content",
          "error_media_concurrency_limit_violation_auth": "Concurrency error occurred",
          "label_error_still_not_working": "Still not working?",
          "label_error_view_faq": "View FAQ",
          "label_error_removed_from_favourites": "Removed from favourites",
          "label_error_failed_remove_favourites": "Failed to removed from favourites",
          "label_error_failed_add_favourites": "Failed to Add in favourites",
          "error_media_concurrency_limit_violation_auth_desc": "This media is already being played somewhere using your credential",
          "error_media_content_unavailable_in_your_country_desc": "This content is not available for your current geo location",
          "error_media_access_denied_desc": "You are not authenticated to view this content",
          "error_something_wrong_desc": "Sorry, unknown error occured",
          "error_no_network": "No Network",
          "error_no_license_granted": "Valid entitlement license not granted",
          "error_no_license_granted_desc": "Valid entitlement license not granted for the user",
          "error_code": "ERROR CODE",
          "account_other_settings_language": "Language",
          "customer_care_contact_us_title": "Contact Us",
          "customer_care_faq_title": "FAQ",
          "customer_care_privacy_title": "Privacy Policy",
          "customer_care_terms_contact_us": "Contact Us",
          "customer_care_terms_term_of_use": "Term of Use",
          "customer_care_terms_title": "Terms of Use",
          "media_label_on_now": "On Now",
          "player_quality_selector": "Playback Quality",
          "search": "Search shows & movies",
          "search_form_default": "Search",
          "search_no_results": "No results found",
          "search_result_title": "Search Results",
          "search_suggestion": "Suggestions",
          "settings_app_language": "App language",
          "details_related": "Related",
          "listing_empty_page": "No content to list",
          "catalog_related_movie": "Related",
          "catalog_related_series": "Related",
          "catalog_label_on_now": "On Now",
          "label_empty_page": "No items found",
          "label_catalog_time_left_label_suffix": "min left",
          "label_catalog_unit_hour": "h",
          "label_catalog_unit_minute": "min",
          "label_catalog_appletv_version": "VERSION",
          "label_catalog_share_title": "Choose One ",
          "details_days": "Days",
          "details_day": "Day",
          "details_hours": "Hours",
          "details_hour": "Hour",
          "details_minutes": "Minutes",
          "details_minute": "Minute",
          "details_seconds": "Seconds",
          "details_second": "Second",
          "details_date": "Date",
          "details_date_st": "st",
          "details_date_nd": "nd",
          "details_date_rd": "rd",
          "details_date_th": "th",
          "details_api_date_format": "yyyy-MM-dd",
          "button_close": "Close",
          "button_ok": "OK",
          "button_update": "Update",
          "button_retry": "Retry",
          "login_register": "REGISTER NOW",
          "login_login": "SIGN IN",
          "button_intro_get_started": "GET STARTED",
          "button_intro_next": "NEXT",
          "button_mobile_web_primary": "Get the App",
          "button_mobile_web_secondary": "Browse",
          "button_web_app_download_banner": "Download",
          "button_cancel": "Cancel",
          "button_web_app_dismiss": "Dismiss",
          "footer_copyright": "Diagnal © 2020",
          "en": "English",
          "fr": "French",
          "label_details_subtitle_prefix": "V.O.:",
          "label_details_episode": "Episode",
          "label_details_country": "Country",
          "label_details_available_for": "Available For",
          "label_details_genre": "Genre",
          "label_details_cast": "Cast",
          "label_details_director": "Director",
          "label_details_show_less": "SHOW LESS",
          "label_details_show_more": "SHOW MORE",
          "label_details_season": "Season ",
          "label_details_trailer": "Trailer",
          "label_details_episode_prefix": "Ep",
          "label_details_season_prefix": "S",
          "label_details_seasons": "Seasons",
          "label_details_h": "h",
          "label_details_min": "min",
          "label_details_sec": "sec",
          "label_details_add_favourite": "Added to favourite",
          "label_details_go": "Go",
          "label_details_play": "PLAY",
          "label_details_cc": "CC",
          "label_details_hd": "HD",
          "label_details_more_info": "MORE INFO",
          "label_details_episodes": "Episodes",
          "label_details_related": "Related",
          "label_details_add_downloads": "Added to downloads",
          "label_details_play_trailer": "PLAY TRAILER",
          "label_details_use_mobile_data": "Use mobile data?",
          "label_details_mobile_data_description": "You’re about to stream the video on your mobile data. Are you sure?",
          "details_play": "Play",
          "details_cancel": "Cancel",
          "label_details_copy_link": "COPY LINK",
          "label_details_share": "Share",
          "label_details_resume": "Resume",
          "label_details_favourite": "FAVOURITE",
          "label_details_unfavourite": "UNFAVOURITE",
          "label_details_url_copied": "URL copied to clipboard",
          "label_player_subtitles": "Subtitles",
          "label_player_language_options": "Language Options",
          "label_player_subtitle": "Subtitles",
          "label_player_auto": "Auto",
          "label_player_off": "off",
          "label_player_season_no": "Season #",
          "label_player_episode_no": "Episode",
          "label_player_next": "Next",
          "label_player_quality_selector": "Playback Quality",
          "subtitle_none": "Off",
          "subtitle_en": "English",
          "subtitle_fr": "French",
          "quality_auto": "Auto",
          "label_playing_on_tv_screen": "Now playing on your TV screen",
          "player_control_next": "Next",
          "subtitle_un": "",
          "player_label_mute": "Mute",
          "player_label_unmute": "Unmute",
          "label_binge_up_next": "UP NEXT",
          "label_binge_episode": "Episode",
          "label_binge_starting_in": "Starting in",
          "label_binge_seconds": "seconds",
          "binge_starting_now": "Starting now",
          "label_binge_up_next_on": "Up Next On",
          "label_binge_now_playing": "Now playing",
          "label_favourites_remove": "Remove",
          "label_favourites_edit": "Edit",
          "label_favourites_edit_favourites": "Edit Favourites",
          "label_favourites_done": "Done",
          "label_favourites": "Favourites",
          "label_settings_stream_mobile_data": "Stream on Mobile Data",
          "label_settings_stream_quality": "Stream Quality",
          "label_settings_autoplay_next_episode": "Autoplay Next Episode",
          "label_settings_download_mobile_data": "Download on Mobile Data",
          "label_settings_download_quality": "Download quality",
          "label_settings_download_storage": "Download Storage",
          "label_settings_internal": "Internal",
          "label_settings_sd_card": "SD Card",
          "label_settings_sd": "SD",
          "label_settings_hd": "HD",
          "label_settings_auto_play_on": "ON",
          "label_settings_auto_play_off": "OFF",
          "label_settings_version": "VERSION",
          "label_download_downloading": "DOWNLOADING",
          "label_download_mb": "MB",
          "label_download_sd_card": "SD Card",
          "label_download_available_for": "AVAILABLE FOR",
          "label_download_days": "DAYS",
          "label_download_expired": "EXPIRED",
          "label_download_total_storage_used": "Total Storage Used: ",
          "label_download_gb": "GB",
          "label_download_internal": "Internal",
          "label_download_edit_download": "Edit Downloads",
          "label_download_downloads": "Downloads",
          "label_download_day": "DAY",
          "label_download_paused": "PAUSED",
          "label_download_queued": "QUEUED",
          "label_download_preparing": "Preparing for download...",
          "label_download_kb": "KB",
          "label_web_app_download_banner_title": "",
          "label_web_app_download_banner_description": "Download the free app from the App Store or Google Play to watch Club illico on your mobile devices.",
          "label_download_season": "S",
          "label_download_episode": "E",
          "label_download_failed": "Failed",
          "label_download_no_play_sd_card": "No media to play in SD Card",
          "label_downloade_low_space_description": "You can free up space on this device by managing your storage in settings",
          "label_download_low_space_title": "Low space warning",
          "error_download_list_pause_data_restriction": "Paused on mobile data",
          "error_download_list_fetch": "Media Fetch Error",
          "error_download_list_parse": "Media Parse Error",
          "error_download_list_format": "Media Format Error",
          "error_download_list_drm": "DRM Error",
          "error_download_list_concurrency": "Concurrency Error",
          "error_download_list_geo_blocked": "Geo-blocked Error",
          "error_download_list_entitlement": "Entitlement Error",
          "error_download_list_preparing": "Preparing failed",
          "error_download_list_low_space": "Low space Error",
          "error_download_list_storage": "Storage Error",
          "error_download_list_network": "Network Error",
          "error_download_list_missing_files": "Missing Files",
          "label_download_low_space_description": "You can free up space on this device by managing your storage in settings",
          "error_download_list_generic": "Unknown error",
          "error_download_list_db_error": "Failed to insert data",
          "label_download_manager": "Download Manager",
          "label_recently_watched_continue_watching": "Continue Watching",
          "label_recently_watched_min": "min",
          "label_recently_watched_hr": "hr",
          "label_recently_watched_sec": "sec",
          "label_recently_watched_left": "left",
          "label_recently_watched_s": "S",
          "label_recently_watched_e": "E",
          "logout_popup_title": "Are you sure?",
          "logout_popup_description": "You will lose access to your shows and movies until you login again",
          "label_logout_cancel": "Cancel",
          "logout_popup_ok": "SIGN OUT",
          "label_component_view_all": "View All",
          "search_more_results": "More Results",
          "search_recent_search": "RECENT SEARCHES",
          "search_no_recent_search": "No Recent Search",
          "search_clear_all": "CLEAR ALL",
          "label_search_hint": "Search",
          "label_search_text": "Search Movies and Series",
          "label_search_result": "Results",
          "label_search_clear_search": "Clear Recent Searches",
          "label_search_suggestion": "Suggestions",
          "login_poup_title": "You are one step away!",
          "login_poup_yes": "YES",
          "registration_poup_title": "Already got an account?",
          "label_popup_download_limit": "Maximum downloads exceeded",
          "label_goto_downloads": "Do you want to go to download page?",
          "login_popup_yes": "YES",
          "login_popup_no": "NO",
          "label_login_progress_description": "Waiting for sign-in to complete",
          "label_mobile_web_primary_text": "Watch Club Illico on your phone or tablet",
          "label_mobile_web_secondary_text": "Download the free app from the App Store or Google Play to watch Club illico on your mobile devices.",
          "label_mobile_web_confirm_text": "Or continue browsing here",
          "label_popup_change_settings_mobile_data": "Change in Settings to Download on Mobile Data",
          "label_chromecast_cast_to": "Cast to",
          "label_chromecast_casting_to": "Casting to",
          "label_chromecast_start_cast": "Starting Cast to",
          "label_chromcast_up_next_on": "Up Next on",
          "label_chromecast_cast": "Casting",
          "label_intro_skip": "Skip",
          "label_intro_next": "NEXT",
          "label_intro_get_started": "GET STARTED",
          "label_login_banner_title": "Connect to your Account",
          "label_login_description": "Enter the code above to sign-in on Club Illico’s website at",
          "label_login_or_description": "or scan the QR code below with your mobile phone or tablet to access the website",
          "label_login_send_code": "SEND CODE AGAIN",
          "contact_us_subtitle": "",
          "contact_us_link_description": "",
          "contact_us_phone_description": "",
          "contact_us_email_description": "",
          "contact_us_phone_no": "",
          "contact_us_link": "",
          "contact_us_link_label": "",
          "label_log_in_account": "Don't have an account?",
          "label_log_in_sign_up": "SIGN UP",
          "label_sign_up_or": "or",
          "label_forgot_password_log_in": "LOG IN",
          "label_log_in_forgot_password": "Forgot Password?",
          "label_sign_up_please_enter_password": "Please enter password",
          "label_sign_up_please_enter_email": "Please enter email",
          "label_account_recovery_change_password": "CHANGE PASSWORD",
          "label_account_recovery_new_password": "Create a new password below and you're good to go",
          "label_account_recovery_reset_password": "Reset Password",
          "label_sign_up_error_password_missmatch_confirm_password": "Password mismatch in confirm password",
          "label_sign_up_confirm_password": "Confirm Password",
          "label_sign_up_password": "Password",
          "label_sign_up_already_account": "Already got an account?",
          "label_sign_up_agree_terms_of_use_and_privacy_policy": "I have read and agree to the ",
          "label_sign_up_create_account": "Create your account",
          "label_sign_up_unlock_exclusive_match_and_live_content": "Unlock exclusive matches and live content",
          "label_sign_up_receive_promotional_messages": "I would like to receive promotional messages",
          "label_forgot_password_send_email": "SEND EMAIL",
          "label_forgot_password_it_is_alright": "It's alright",
          "label_forgot_password_email": "Enter your email below and we'll get it sorted",
          "label_account_info_your_profile": "Your Profile",
          "label_account_info_about_yourself": "Tell us a bit about yourself",
          "label_account_info_first_name_invalid": "Invalid first name ",
          "label_account_info_last_name_invalid": "Invalid last name",
          "label_sign_up_please_enter_date_of_birth": "Please enter Date of Birth",
          "label_sign_up_please_enter_gender": "Please enter gender",
          "label_account_info_start_watching": "START WATCHING",
          "label_account_info_skip_for_now": "Skip for now",
          "label_account_info_first_name": "First Name",
          "label_account_info_last_name": "Last Name",
          "label_account_info_date_of_birth": "Date of Birth",
          "label_account_info_gender": "Gender",
          "label_sign_up_email": "Email",
          "label_sign_up_error_enter_valid_email": "Enter a valid email ",
          "label_sign_up_error_minimum_password_character": "Minimum number of characters is ",
          "label_account_edit_profile": "Edit Profile",
          "label_account_password": "Password",
          "label_change_password_text": "Change your password regularly",
          "label_account_change": "Change",
          "label_account_purchase_history": "Purchase History",
          "label_purchase_history_text": "See all the passes you've purchased",
          "label_account_view": "View",
          "label_account_current_password": "Current Password",
          "label_sign_up_error_minimum_first_name_character": "Minimum characters for first name is ",
          "label_sign_up_error_maximum_last_name_character": "Maximum characters for last name is ",
          "label_profile_new_profile": "CREATE A NEW PROFILE",
          "label_profile_update_pin": "UPDATE KIDS PIN",
          "label_profile_popup_title": "Profiles",
          "label_profile_kids_avatar_label": "Kids",
          "label_profile_popup_title_edit_profile": "Edit Profiles",
          "label_profile_edit_profile_name": "Profile name",
          "label_profile_edit_profile_edit_profile": "Edit Profile",
          "label_profile_edit_profile_kids_profile": "Kids Profile",
          "label_profile_edit_profile_kids_profile_description": "Enable Kid's only experience with titles suitable for Kids  ",
          "label_profile_edit_profile_push_notification": "Push notifications",
          "label_profile_edit_profile_push_notification_description": "Enable to receive relevant push notifications for this profile",
          "label_profile_edit_profile_button_save_changes": "SAVE CHANGES",
          "label_profile_edit_profile_button_cancel": "CANCEL",
          "label_profile_edit_profile_delete_popup_title": "Are you sure?",
          "label_profile_edit_profile_delete_popup_description": "All of the data associated with this profile will also be deleted. This cannot be undone.",
          "label_profile_edit_profile_delete_popup_button_confirm": "CONFIRM",
          "label_profile_edit_profile_delete_popup_button_cancel": "CANCEL",
          "label_profile_edit_profile_require_pin_profile_exit_description": "Enable to make Kid's pin mandatory for switching out from this profile. ",
          "label_profile_edit_profile_require_pin_profile_exit": "Require Kids PIN on profile exit",
          "label_profile_edit_profile_avatar_kids": "Kids",
          "label_profile_create_profile_create_profile": "Create Profile",
          "label_profile_create_profile_profile_name": "Profile name",
          "label_profile_create_profile_kids_profile": "Kids Profile",
          "label_profile_create_profile_kids_profile_description": "Enable Kid's only experience with titles suitable for Kids ",
          "label_profile_create_profile_push_notification": "Push notifications",
          "label_profile_create_profile_push_notification_description": "Enable to receive relevant push notifications for this profile",
          "label_profile_create_profile_button_create_profile": "CREATE PROFILE",
          "label_profile_create_profile_button_cancel": "CANCEL",
          "label_profile_create_profile_avatar_kids": "Kids",
          "label_profile_create_profile_require_pin_profile_exit_description": "Enable to make Kid's pin mandatory for switching out from this profile. ",
          "label_profile_create_profile_require_pin_profile_exit": "Require Kids PIN on profile exit",
          "label_profile_create_profile_profile_created_toast": "has been created",
          "label_profile_popup_create_kids_pin_popup_title": "Create Kids PIN",
          "label_profile_popup_create_kids_pin_popup_description": "Kids PIN is required to change a kids profile to full access and can also be used to control exit from a kids profile.",
          "label_profile_popup_create_kids_pin_popup_button_next": "NEXT",
          "label_profile_popup_create_kids_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_create_kids_pin_popup_only_number_warning": "Please only use numbers for your PIN.",
          "label_profile_popup_new_kids_pin_confirm_popup_title": "Confirm Kids PIN",
          "label_profile_popup_new_kids_pin_confirm_popup_description": "Enter the same digits you’ve entered earlier to confirm.",
          "label_profile_popup_new_kids_pin_confirm_popup_button_done": "DONE",
          "label_profile_popup_new_kids_pin_confirm_popup_button_cancel": "CANCEL",
          "label_profile_popup_new_pin_created_popup_title": "Kids PIN created",
          "label_profile_popup_new_pin_created_popup_description": "To change the Kids PIN, switch to any profile with full access.",
          "label_profile_popup_new_pin_created_popup_button_ok": "OK",
          "label_profile_popup_verify_pin_popup_title": "Enter Kids PIN",
          "label_profile_popup_verify_pin_popup_description": "Before you can change the kids PIN, please enter the existing PIN.",
          "label_profile_popup_verify_pin_popup_forgot_pin": "Forgot PIN",
          "label_profile_popup_verify_pin_popup_button_next": "NEXT",
          "label_profile_popup_verify_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_verify_pin_popup_wrong_pin_toast": "The PIN you’ve entered is incorrect",
          "label_profile_popup_wrong_pin_popup_title": "Reset Kids PIN?",
          "label_profile_popup_wrong_pin_popup_description": "You’ve entered an incorrect PIN five times already. Would you like to reset your Kids PIN? This requires you to login again before setting a new PIN.",
          "label_profile_popup_wrong_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_wrong_pin_popup_button_confirm": "CONFIRM",
          "label_profile_popup_forgot_pin_popup_title": "Forgot Kids PIN?",
          "label_profile_popup_forgot_pin_popup_description": "Would you like to reset your Kids PIN? This requires you to login again before setting a new PIN.",
          "label_profile_popup_forgot_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_forgot_pin_popup_button_reset": "RESET",
          "label_profile_popup_change_pin_popup_title": "Change Kids PIN",
          "label_profile_popup_change_pin_popup_description": "Kids PIN is required to change a kids profile to full access and can also be used to control exit from a kids profile.",
          "label_profile_popup_change_pin_popup_button_done": "DONE",
          "label_profile_popup_change_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_change_pin_confirmation_popup_title": "Kids PIN changed",
          "label_profile_popup_change_pin_confirmation_popup_description": "The new kids PIN can now be used to control exit from a kids profile",
          "label_profile_popup_change_pin_confirmation_popup_button_ok": "OK",
          "label_profile_popup_exit_kids_popup_title": "Enter Kids PIN",
          "label_profile_popup_exit_kids_popup_description": "Please enter your Kids PIN to switch out of this profile.",
          "label_profile_popup_exit_kids_popup_button_done": "DONE",
          "label_profile_popup_exit_kids_popup_button_cancel": "CANCEL",
          "label_profile_popup_exit_kids_popup_forgot_pin": "FORGOT PIN",
          "label_profile_popup_max_profiles_popup_title": "Maximum profiles reached",
          "label_profile_popup_max_profiles_popup_description": "You can only create five profiles. Please remove an existing profile before creating a new one.",
          "label_profile_popup_max_profiles_popup_button_ok": "OK"
        },
        "detailsType": "movie",
        "previewAssetFormat": "MPEG4,MPEG-DASH+widevine,MPEG-DASH+none",
        "theme": {
          "header": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(0, 0, 0, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "curvedEdges": true
          },
          "body": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(43, 43, 43, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(146, 146, 146, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(222, 222, 222, 1)",
              "error": null
            }
          },
          "footer": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(115, 115, 115, 1)",
              "tertiary": "rgba(43, 43, 43, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(222, 222, 222, 1)",
              "error": null
            }
          },
          "compositeStyle": {
            "calendarStyle": {
              "body": {
                "accent": {
                  "primary": "#f7f72a",
                  "secondary": "#FFF",
                  "tertiary": "#4d4d4d"
                },
                "background": {
                  "primary": "#f7f72a",
                  "secondary": "#333333",
                  "tertiary": "#000000"
                },
                "text": {
                  "primary": "#FFF",
                  "secondary": "#C0C0C0",
                  "tertiary": "#999999"
                }
              }
            },
            "primaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "secondaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "primaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "focussed": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "secondaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "focussed": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "tertiaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "sliderIndicator": {
              "normal": {
                "background": "rgba(115, 115, 115, 1)",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "selectorStyle": {
              "normal": {
                "background": "#f7f72a",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "dropdownStyle": {
              "normal": {
                "background": "rgba(34, 34, 34, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(68, 68, 68, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "toastTheme": {
              "accent": {
                "primary": "rgba(255, 228, 0, 1)",
                "secondary": "#f7f72a",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "background": {
                "primary": "rgba(43, 43, 43, 1)",
                "secondary": "#000",
                "tertiary": "#000",
                "error": null
              },
              "text": {
                "primary": "rgba(255, 255, 255, 1)",
                "secondary": "rgba(255, 228, 0, 1)",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "curvedEdges": true
            }
          },
          "graphics": [
            {
              "id": "app_header_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            },
            {
              "id": "app_splash",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/splash_web.png",
                  "orientation": "landscape"
                }
              ]
            },
            {
              "id": "app_popup_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            }
          ]
        },
        "images": [
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_2048x1152_16294981697.jpg",
            "type": "landscape",
            "width": 2048,
            "height": 1152
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_828x464_16294981698.jpg",
            "type": "landscape",
            "width": 828,
            "height": 464
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_760x428_16294981699.jpg",
            "type": "landscape",
            "width": 760,
            "height": 428
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_526x296_16294981700.jpg",
            "type": "landscape",
            "width": 526,
            "height": 296
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_1280x720_15921221815.jpg",
            "type": "landscape",
            "width": 1280,
            "height": 720
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_large.jpg",
            "type": "square",
            "width": 1080,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_medium.jpg",
            "type": "square",
            "width": 640,
            "height": 640
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_small.jpg",
            "type": "square",
            "width": 360,
            "height": 360
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_2_3_small.jpg",
            "type": "portrait",
            "width": 210,
            "height": 315
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_large.jpg",
            "type": "landscape",
            "width": 1440,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 525
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_small.jpg",
            "type": "landscape",
            "width": 300,
            "height": 225
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_large.jpg",
            "type": "landscape",
            "width": 1500,
            "height": 570
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 226
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_small.jpg",
            "type": "landscape",
            "width": 480,
            "height": 182
          }
        ],
        "metaTheme": {
          "header": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(0, 0, 0, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(166, 166, 166, 1)",
              "error": null
            },
            "curvedEdges": true
          },
          "body": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(43, 43, 43, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(146, 146, 146, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(166, 166, 166, 1)",
              "tertiary": "rgba(255, 255, 255, 1)",
              "error": null
            }
          },
          "footer": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(115, 115, 115, 1)",
              "tertiary": "rgba(43, 43, 43, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(222, 222, 222, 1)",
              "error": null
            }
          },
          "compositeStyle": {
            "calendarStyle": {
              "body": {
                "accent": {
                  "primary": "#f7f72a",
                  "secondary": "#FFF",
                  "tertiary": "#4d4d4d"
                },
                "background": {
                  "primary": "#f7f72a",
                  "secondary": "#333333",
                  "tertiary": "#000000"
                },
                "text": {
                  "primary": "#FFF",
                  "secondary": "#C0C0C0",
                  "tertiary": "#999999"
                }
              }
            },
            "primaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "secondaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "primaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(0, 0, 0, 0)"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "secondaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "tertiaryButton": {
              "normal": {
                "background": "#f7f72a",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "sliderIndicator": {
              "normal": {
                "background": "rgba(115, 115, 115, 1)",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "selectorStyle": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "dropdownStyle": {
              "normal": {
                "background": "rgba(34, 34, 34, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(68, 68, 68, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "toastTheme": {
              "accent": {
                "primary": "rgba(255, 228, 0, 1)",
                "secondary": "#f7f72a",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "background": {
                "primary": "rgba(43, 43, 43, 1)",
                "secondary": "#000",
                "tertiary": "#000",
                "error": null
              },
              "text": {
                "primary": "rgba(255, 255, 255, 1)",
                "secondary": "rgba(255, 228, 0, 1)",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "curvedEdges": true
            }
          },
          "graphics": [
            {
              "id": "app_header_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            },
            {
              "id": "app_splash",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/splash_web.png",
                  "orientation": "landscape"
                }
              ]
            },
            {
              "id": "app_popup_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            }
          ]
        },
        "baseUrl": "https://api-comcast.create.diagnal.com",
        "progress": 0,
        "isCcAvailable": false,
        "parentalControl": [
          {}
        ],
        "displayDuration": null,
        "contentGuid": "FQ5Wd1wjZFy39eve9RWp23HrHjSAaGfc",
        "purchaseMode": "free",
        "percentComplete": 100,
        "isProductLoading": false,
        "streams": "https://link.theplatform.com/s/tzTJhC/media/ad_yEfI0NVSl",
        "smilUrl": "https://link.theplatform.com/s/tzTJhC/media/ad_yEfI0NVSl",
        "episodeNum": "",
        "thumbnailImgs": [
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_2048x1152_16294981697.jpg",
            "type": "landscape",
            "width": 2048,
            "height": 1152
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_828x464_16294981698.jpg",
            "type": "landscape",
            "width": 828,
            "height": 464
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_760x428_16294981699.jpg",
            "type": "landscape",
            "width": 760,
            "height": 428
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_526x296_16294981700.jpg",
            "type": "landscape",
            "width": 526,
            "height": 296
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_1280x720_15921221815.jpg",
            "type": "landscape",
            "width": 1280,
            "height": 720
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_large.jpg",
            "type": "square",
            "width": 1080,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_medium.jpg",
            "type": "square",
            "width": 640,
            "height": 640
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_small.jpg",
            "type": "square",
            "width": 360,
            "height": 360
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_2_3_small.jpg",
            "type": "portrait",
            "width": 210,
            "height": 315
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_large.jpg",
            "type": "landscape",
            "width": 1440,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 525
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_small.jpg",
            "type": "landscape",
            "width": 300,
            "height": 225
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_large.jpg",
            "type": "landscape",
            "width": 1500,
            "height": 570
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 226
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_small.jpg",
            "type": "landscape",
            "width": 480,
            "height": 182
          }
        ]
      }
    }
    history.push(`${routeMap.player}?mediaId=277046310581&progress=0&duration=null`, state)

  }
  /* --------------------------------------------- */
   /**
   * It: Enable/disable body scroll.
   */
  useEffect(() => {
    let contentEl = detailsPopupRef.current
    utils.disableScroll(contentEl, { reserveScrollBarGap: true })
    globalDispatch({ 
      type: 'POPUP_DETAILS', 
      value: {
        inViewport: true,
        useMargin: utils.hasMargin()
      }
    })
    return () => {
      utils.enableScroll(contentEl)
      globalDispatch({ 
        type: 'POPUP_DETAILS', 
        value: {
          inViewport: false,
          useMargin: utils.hasMargin()
        }
      })
    }
  }, [globalDispatch])
  /* --------------------------------------------- */
  return (
    <div className={`details-page__pop-up details-page__pop-up---media ${isShow ? 'details-page__pop-up---open' : ''}`}>
      <DetailsPopup theme={metaTheme} ref={detailsPopupRef} className={`details-page__pop-up-wrapper ${!railItemDetails ? 'details-page__pop-up-wrapper---empty' : ''}`}>
        {!railItemDetails && <Spinner size={30} />}
        <div className='details-page__pop-up-head'>
          <div>
            {railItemDetails && <BodyTextSecondary {...{ metaTheme }} className='episode-data'>{railItemDetails.seriesTitle && <span>{railItemDetails.seriesTitle}</span>} {railItemDetails.seasonNumber && <span>{appMessages.label_details_season} {railItemDetails.seasonNumber}</span>}{railItemDetails.episodeNumber && <span>{appMessages.label_details_episode} {railItemDetails.episodeNumber}</span>}</BodyTextSecondary>}
            {type && type === 'episode' ? <DetailsPagePopupHeader {...{ metaTheme }}>{(railItemDetails && railItemDetails.episodeTitle) || title}</DetailsPagePopupHeader> : <DetailsPagePopupHeaderPrimary {...{ metaTheme }}>{(railItemDetails && railItemDetails.episodeTitle) || title}</DetailsPagePopupHeaderPrimary>}
          </div>
          <div className='player-audio__close' onClick={closeBtnHandle}>
            <CloseIcon color={metaTheme && metaTheme.header && metaTheme.header.accent.primary} style={{ width: 18, height: 18 }} />
          </div>
        </div>

        <div className='details-section-header__badges'>
          {railItemDetails &&
            <DetailsPageBadges {...{ metaTheme }} >
              <p>{railItemDetails.displayDuration && <span className='duration'>{railItemDetails.displayDuration}</span>}{railItemDetails.releaseYear && <span className='releaseYear'>{railItemDetails.releaseYear}</span>}</p>
              {( (railItemDetails.parentalControl && railItemDetails.parentalControl[0] && railItemDetails.parentalControl[0].rating) || railItemDetails.isCcAvailable|| railItemDetails.isHdAvailable) && <div>
                {railItemDetails.parentalControl && railItemDetails.parentalControl[0] && railItemDetails.parentalControl[0].rating && <li className='filled'>{railItemDetails.parentalControl[0].rating}</li>}
                {railItemDetails.isCcAvailable && <li className='hollow'>{appMessages.label_details_cc}</li>}
                {railItemDetails.isHdAvailable && <li className='hollow'>{appMessages.label_details_hd}</li>}
              </div>}
            </DetailsPageBadges>}
        </div>
        {railItemDetails &&
          <div className='details-page__pop-up-content'>
            <DescriptionText className='description' {...{ metaTheme }}>{railItemDetails.description}</DescriptionText>
            <div className='details-section-details'>
              {
                (railItemDetails.details || []).map(({ key, label, value }, i) => {
                  return value && value.length && (
                    <div key={i} className='details-section-details-row'>
                      <MetaBodyTextSecondary {...{ metaTheme }} className='details-section-details-title'>
                        {label}
                      </MetaBodyTextSecondary>
                      <MetaBodyTextTertiary {...{ metaTheme }} className='details-section-details-description'>
                        {(value || []).map(({ title }, i) => {
                          if (key === 'availableTill' || key === 'countries') {
                            return (
                              <span key={title}>{title}
                                {value.length - 1 === i ? '' : ', '}
                              </span>
                            )
                          } else {
                            return (
                              <Link key={title} to={`${routeMap.listing}?search=${title}&mode=${key.toLowerCase()}`}>{title}
                                {value.length - 1 === i ? '' : ', '}
                              </Link>
                            )
                          }
                        })}
                      </MetaBodyTextTertiary>
                    </div>
                  )
                }).filter((res) => res)
              }
            </div>
          </div>}
        {shouldShowPlay && railItemDetails.isLive ? <PlayButton onClick={showPlayer} text='Watch Now' /> : null}
      </DetailsPopup>
    </div>
  )
}
/* --------------------------------------------- */
MediaDetailsPopUp.defaultProps = {}
/* --------------------------------------------- */
export default MediaDetailsPopUp
/* --------------------------------------------- */
